import React, { useState } from "react";
import { Link } from "react-router-dom";
import BloodPressure from "./BloodPressure";
import HeartRate from "./HeartRate";
import Temperature from "./Temperature";
import OxygenSaturation from "./OxygenSaturation";
import RespirationRate from "./RespirationRate";
import Height from "./Height";
import HeadCircumference from "./HeadCircumference";
import Weight from "./Weight";

const PatientVitals = ({ patientObj = null }) => {
  const [activeTab, setActiveTab] = useState("bloodPressure");

  const tabs = [
    { id: "bloodPressure", label: "Blood Pressure", component: BloodPressure },
    { id: "heartRate", label: "Heart Rate", component: HeartRate },
    { id: "temperature", label: "Temperature", component: Temperature },
    {
      id: "oxygenSaturation",
      label: "Oxygen Saturation",
      component: OxygenSaturation,
    },
    {
      id: "respirationRate",
      label: "Respiration Rate",
      component: RespirationRate,
    },
    { id: "height", label: "Height", component: Height },
    {
      id: "headCircumference",
      label: "Head Circumference",
      component: HeadCircumference,
    },
    { id: "weight", label: "Weight", component: Weight },
  ];

  const ActiveComponent = tabs.find((tab) => tab.id === activeTab)?.component;

  return (
    <div className="p-4 bg-white rounded-10 shadow-sm mb-4">
      <h3 className="mb-4">Patient Vitals</h3>
      <div className="inner-menu-container bg-white shadow-sm">
        <div className="container-fluid">
          <ul
            className="nav secondary-menu mw-100 flex-nowrap gap-1 gap-sm-2 gap-lg-3 flex-fill fs-sm fw-semibold text-center border-0 text-nowrap overflow-auto"
            id="vitalsTab"
            role="tablist"
          >
            {/* ------- map loop -------- */}
            {tabs.map((tab, index) => {
              return (
                <li key={index} className="nav-item flex-fill">
                  <Link
                    to="#"
                    id={`${tab.id}-tab`}
                    data-bs-toggle="tab"
                    data-bs-target={`#${tab.id}`}
                    className={`d-block text-black px-2 px-sm-3 py-3 py-sm-4 position-relative ${
                      activeTab === tab.id && "active"
                    } `}
                    type="button"
                    role="tab"
                    aria-controls={tab.id}
                    aria-selected={activeTab === tab.id}
                    onClick={() => setActiveTab(tab.id)}
                  >
                    {tab.label}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </div>

      <div className="tab-content mt-4" id="vitalsTabContent">
        {ActiveComponent && <ActiveComponent patientObj={patientObj} />}
      </div>
    </div>
  );
};

export default PatientVitals;
